// High-quality professional virtual backgrounds
export const BACKGROUNDS = [
  {
    id: 1,
    src: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920&q=80', // Modern office
    name: 'Modern Office',
  },
  {
    id: 2,
    src: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1920&q=80', // Bright workspace
    name: 'Bright Workspace',
  },
  {
    id: 3,
    src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920&q=80', // Mountain landscape
    name: 'Mountain View',
  },
  {
    id: 4,
    src: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1920&q=80', // Forest path
    name: 'Forest Path',
  },
  {
    id: 5,
    src: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1920&q=80', // Beach sunset
    name: 'Beach Sunset',
  },
  {
    id: 6,
    src: 'https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=1920&q=80', // Minimalist office
    name: 'Minimalist Office',
  },
  {
    id: 7,
    src: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1920&q=80', // Tech workspace
    name: 'Tech Workspace',
  },
  {
    id: 8,
    src: 'https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=1920&q=80', // Nature landscape
    name: 'Nature Landscape',
  },
  {
    id: 9,
    src: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=1920&q=80', // Gradient abstract
    name: 'Abstract Gradient',
  },
  {
    id: 10,
    src: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174?w=1920&q=80', // Cozy home office
    name: 'Cozy Home Office',
  },
  {
    id: 11,
    src: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1920&q=80', // Living room with window
    name: 'Living Room',
  },
  {
    id: 12,
    src: 'https://images.unsplash.com/photo-1462826303086-329426d1aef5?w=1920&q=80', // Conference room
    name: 'Conference Room',
  },
  {
    id: 13,
    src: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=1920&q=80', // Tropical resort
    name: 'Tropical Beach',
  },
  {
    id: 14,
    src: 'https://images.unsplash.com/photo-1531306728370-e2ebd9d7bb99?w=1920&q=80', // Space galaxy
    name: 'Space Galaxy',
  },
  {
    id: 15,
    src: 'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=1920&q=80', // Northern lights
    name: 'Northern Lights',
  },
  {
    id: 16,
    src: 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=1920&q=80', // Colorful gradient
    name: 'Colorful Gradient',
  },
  {
    id: 17,
    src: 'https://images.unsplash.com/photo-1490806843957-31f4c9a91c65?w=1920&q=80', // Brick wall
    name: 'Brick Wall',
  },
];

export const ANIMATED_BACKGROUNDS = [];

export const BLURRED_BACKGROUNDS: { title: string; id: 'slight-blurred' | 'fully-blurred' }[] = [
  { id: 'slight-blurred', title: 'Slightly blurred' },
  { id: 'fully-blurred', title: 'Fully blurred' },
];

export const ANIMATED_BACKGROUND_VIDEOS = [
  {
    id: 1,
    src: 'https://v-cdn-bucket-files-prod.s3.eu-central-1.amazonaws.com/public/bubbles-water.mp4',
    thumbnail: 'https://d1isfq5g7of7wk.cloudfront.net/public/bubbles-water.png',
    name: 'Water Bubbles',
  },
  {
    id: 2,
    src: 'https://v-cdn-bucket-files-prod.s3.eu-central-1.amazonaws.com/public/multicolor-ink.mp4',
    thumbnail: 'https://d1isfq5g7of7wk.cloudfront.net/public/multicolor-ink.png',
    name: 'Multicolor Ink',
  },
  {
    id: 3,
    src: 'https://v-cdn-bucket-files-prod.s3.eu-central-1.amazonaws.com/public/night-sky-with-stars.mp4',
    thumbnail: 'https://d1isfq5g7of7wk.cloudfront.net/public/night-sky-with-stars.png',
    name: 'Night Sky',
  },
  {
    id: 5,
    src: 'https://v-cdn-bucket-files-prod.s3.eu-central-1.amazonaws.com/public/cat.mp4',
    thumbnail: 'https://d1isfq5g7of7wk.cloudfront.net/public/cat.png',
    name: 'Cute Cat',
  },
  {
    id: 6,
    src: 'https://v-cdn-bucket-files-prod.s3.eu-central-1.amazonaws.com/public/cosmic_purple_720_30fps.mp4',
    thumbnail: 'https://d1isfq5g7of7wk.cloudfront.net/public/cosmic_purple_720_30fps.png',
    name: 'Cosmic Purple',
  },
];
